export enum SignupView {
  EMAIL_PASSWORD = 'EMAIL_PASSWORD',
  SSO = 'SSO',
  SSO_EMAIL_PASSWORD = 'SSO_EMAIL_PASSWORD',
}
